* {
  box-sizing: border-box;
}

:host {
  display: inline-flex;
  max-width: 100%;
}

.nav-button {
  margin: 0 auto;
  height: 24px;
  z-index: 9999;
  border: none;
  background-color: var(--chart-051-hover);
  border-radius: 6px;
  padding: 0 calc(2 * var(--spacer));
  cursor: pointer;
  display: inline-flex;
  transition: opacity 0.3s ease-in-out;
  align-items: center;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;

  span {
    font-size: var(--body-size-large);
    color: var(--chart-300-icon-buttons);
    font-family: var(--font-family-secondary);
  }

  gz-icon {
    margin-left: calc(-1 * var(--spacer));
  }

  &:hover {
    background-color: var(--chart-051-hover);
    border-color: var(--white-layout-050-hover-on-dark-background);

    span {
      color: var(--black-layout-700-primary);
    }

    gz-icon::part(svgIcon) {
      fill: var(--black-layout-700-primary);
    }
  }

  &:focus-visible {
    outline: 2px solid var(--blue-layout-500-focus);
  }

  &:active {
    border-color: transparent;
  }

  &[disabled] {
    background-color: var(--chart-051-hover);

    gz-icon::part(svgIcon) {
      fill: var(--grey-layout-203-dark-theme-disabled-text);
    }

    span {
      color: var(--grey-layout-203-dark-theme-disabled-text);
    }
  }

  &.top,
  &.bottom {
    white-space: nowrap;
  }
}
